import React, { useEffect, useState } from 'react'
import { Badge, Button, Card, ListGroup, Stack } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'
import { getDownloadURL, ref } from 'firebase/storage'
import { storage } from '../../firebase'
import ScrollIntersectionObserver from '../CustomControls/ScrollIntersectionObserver'

export default function PresetRentalCard(props) {
  const [url, setUrl] = useState("");  


  useEffect(() => {
    CardHeader()
    setBackgroundImg()
  })

  
  const CardHeader = async () => {
      if(props.rental.vehicle && props.rental.vehicle.media && props.rental.vehicle.media[0].url){

        const gurl =  await getDownloadURL(ref(storage, props.rental.vehicle.media[0].url))
        setUrl(gurl);
      }
  }

  const BagdeVariant = () => { return props.rental.status === "rented" ? 
    <Badge bg="danger">{props.rental.status}</Badge> :
      props.rental.status === "reserved" ? <Badge bg="sucess">{props.rental.status}</Badge> :
      <Badge>{props.rental.status}</Badge>; }

  const setBackgroundImg = () => {
    const background = document.getElementById('rentCard'+props.rental.id)
    let currentBackgroundImg = background.style.backgroundImage
    background.style.backgroundImage = url ? 'url('+ url + ')' : currentBackgroundImg;
  }

  const location = useLocation();
  const isHome = location.pathname == '/';

  return (
          <Card style={{ maxWidth: "600px"}} className={ isHome ? 'rent-card border-0 rounded-3 overflow-hidden lead bk-mint home' 
          : 'rent-card border-0 rounded-3 overflow-hidden lead bk-mint' } id={'rentCard'+props.rental.id}>
            <motion.div
                whileTap={{ scale: 0.9 }}>
                <Button className='rent-shced-btn'>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="rent-icon bi bi-plus-circle-fill" viewBox="0 0 16 16">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"/>
                </svg>
                </Button>
            </motion.div>
            <div className='rent-footer rounded-3'>
              <div className='rent-text'>
                <motion.h4 initial={{ scale: 2 }} animate={{ scale: 1}} transition={{ delay: 1.25 }} className='text-center mb-2'>{props.rental.display_name}</motion.h4>
               {props.rental.vehicle && <p>{props.rental.vehicle.year} {props.rental.vehicle.model} {props.rental.vehicle.make}</p>}
              </div>
              <div className='rent-price'>
                <span className='rg-label gold'>${props.rental.cost_per_hour} JAD</span>
                    {/* Bond: {props.rental.bond} */}

                    <motion.div className='ms-auto'
                        whileTap={{ scale: 0.9 }}>
                        <Link
                            role='button' 
                            className='btn bt-dark'
                            to={'/rentals/reserve/' + props.rental.id}>Reserve
                        </Link>
                    </motion.div>
              </div>
            { isHome ? <ScrollIntersectionObserver element='rent-card' isClass={true} /> : null }
            </div>
        </Card>
    )
}
